<template>
  <div class="field__form-textarea">
    <textarea
        @input="changeValue"
        :required="required"
        :placeholder="placeholder"
        v-text="modelValue"></textarea>
    <label v-text="label"/>
    <div class="clear">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.33333 9.33333L14.6667 14.6667M14.6667 9.33333L9.33333 14.6667M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
            stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <AlertBox :is-show="error" :message="error" />
  </div>

</template>


<script>

import { vMaska } from "maska"
export default {
  name: 'TheTextArea',
  directives: { maska: vMaska },
  props: {
    modelValue: [String, Number],
    error: {
      type: String,
      default: null,
      require: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    label_position_left: {
      type: Boolean,
      default: true,
    },
    class_value: {
      type: String,
      default: '',
    },
    subValue: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    step: {
      type: Number,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    placeholder: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  methods: {
    setFocus(data){
      if(data){
        this.$refs.input?.focus();
      }
    },
    changeValue(event) {
      if (this.min !== null && event.target.value < this.min) {
        event.target.value = this.min
      }
      if (this.max !== null && event.target.value > this.max) {
        event.target.value = this.max
      }
      this.$emit('update:error', null);
      this.$emit('update:modelValue', event.target.value);
    }
  }
};
</script>
<style scoped>


</style>
